import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  registerChangeProgramCampusModality: [
    'procedureId',
    'modality',
    'campus',
    'program',
    'files'
  ],
  // Reducer
  registerChangeProgramCampusModalityClear: null,
  registerChangeProgramCampusModalityRequest: null,
  registerChangeProgramCampusModalitySuccess: null,
  registerChangeProgramCampusModalityFailure: ['error']
});

export { Creators, Types };
